import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/landing-video.mp4'


const _withScopeId = n => (_pushScopeId("data-v-13ff9d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "HomeContainer",
  class: "home_page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo_ hidden-sm-and-up" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo hidden-sm-and-down" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMjkgMTI5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjkgMTI5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZENTc2Mzt9Cjwvc3R5bGU+CjxjaXJjbGUgaWQ9IkVsbGlwc2VfM18xXyIgY2xhc3M9InN0MCIgY3g9IjY0LjQ0IiBjeT0iNjQuNTYiIHI9IjY0Ii8+Cjwvc3ZnPgo=" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@cosmo.io" }, "Contact", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  theme: "[object Object]",
  href: "https://www.instagram.com/cosmomade",
  target: "_blank",
  class: "SocialLinks__Icon-sc-1pbpz3p-0 iwmuvx meta_white"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  theme: "[object Object]",
  href: "https://www.linkedin.com/company/cosmomade",
  target: "_blank",
  class: "SocialLinks__Icon-sc-1pbpz3p-0 iwmuvx in_white"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "fIgTWM" }
const _hoisted_14 = { class: "VideoShow__Overlay-sc-6teiy8-0 kfefbJ animate__animated" }
const _hoisted_15 = { class: "dtJFmb" }
const _hoisted_16 = { class: "dtJFmb" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  autoplay: true,
  loop: "true",
  muted: true,
  playsinline: true,
  style: {"display":"block","height":"100vh","width":"100%","object-fit":"cover"}
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div id=\"Screen2\" class=\"item2 common_item\" data-v-13ff9d9e><div class=\"platform_one\" data-v-13ff9d9e><div data-v-13ff9d9e><h1 class=\"eheunP\" data-v-13ff9d9e>We are an innovative <span class=\"alt\" data-v-13ff9d9e> manufacturing solutions platform </span></h1><h1 class=\"bOuNkl\" data-v-13ff9d9e>merging luxury craftsmanship with consumer-electronics repeatability and scale.</h1></div></div><div class=\"platform_two\" data-v-13ff9d9e></div></div>", 1)
const _hoisted_19 = {
  id: "Screen4",
  class: "item4 common_item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "platform_one" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "eheunP" }, [
      /*#__PURE__*/_createTextVNode("We are pioneers of "),
      /*#__PURE__*/_createElementVNode("span", { class: "alt" }, "engineered soft-goods,")
    ]),
    /*#__PURE__*/_createElementVNode("h1", { class: "bOuNkl" }, "integrating soft-goods with structure and embedded electronics. ")
  ])
], -1))
const _hoisted_21 = { class: "platform_two styles__Half-sc-1d0iomf-1 EngineeredSoftGoods__AniHalf-sc-102jvb3-0 dIxxWj" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item5_title",
  style: {"user-select":"none"}
}, "Our core capabilities", -1))
const _hoisted_24 = { class: "item5_container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_shadow" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "eheunP" }, [
    /*#__PURE__*/_createTextVNode("Our "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#000"} }, "Global innovation labs"),
    /*#__PURE__*/_createTextVNode(" create and accelerate solutions for our customers.")
  ])
], -1))
const _hoisted_27 = {
  id: "Screen8",
  class: "item8 common_item"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("We are on a journey to "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#000","display":"block"} }, "initiate positive change,")
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "driving progress through smart engineering to elevate our global partners with advanced holistic sustainable solutions.")
], -1))
const _hoisted_29 = {
  id: "Screen9",
  class: "item9"
}
const _hoisted_30 = {
  id: "Screen10",
  class: "item10 common_item"
}
const _hoisted_31 = { class: "cVPsOC" }
const _hoisted_32 = { class: "inner" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, ">> Service notice <<", -1))
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  id: "Screen12",
  class: "item12"
}
const _hoisted_36 = { class: "contact_container" }

import { ref, onMounted, reactive } from 'vue';
import TimeLineHeight from './common/TimeLineHeight.vue'
import TimeLineWidth from './common/TimeLineWidth.vue'
import TimeLineWidthMini from './common/TimeLineWidthMini.vue'
import MapItem from './common/MapItem.vue'
import Certifications from './common/Certifications.vue'
import Contact from './common/Contact.vue'
import OurPlatform from './common/OurPlatform.vue'
import OurCommitment from './common/OurCommitment.vue'
// import OurCoreCapabilities from './common/OurCoreCapabilities.vue'

// const dialogVisible = ref<boolean>(true);
interface esg {
  class: {
    [key: string]: boolean,
    expand: boolean
  },
  img?: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const flagClose = ref<boolean>(true);
const item0Obj = reactive<any[]>([
  { class: { animate__fadeInUpBig: false }, text: 'Soft-goods' },
  { class: { animate__fadeInUpBig: false }, text: 'craftsmanship' },
  { class: { animate__fadeInUpBig: false }, text: 'meets automation' }
])
const item1Obj = reactive<any[]>([
  { class: { 'hQZPnx': false, 'eDYhyd': true }, nText: '3', text: 'Factories' },
  { class: { 'kqOdxS': false, 'bEKofS': true }, nText: '1', text: 'Lab' },
  { class: { 'fZkpmP': false, 'jArLJL': true }, nText: '1m+', text: 'Sq. Ft.' },
  { class: { 'leCMfQ': false, 'gfQGQo': true }, nText: '50m+', text: 'Products/Yr' },
  { class: { 'kXbLht': false, 'koHbrt': true }, nText: '10k+', text: 'Employees' },
])
const listImg: string[] = [
  require('@/assets/images/Gallery_DSC2545.jpg'),
  require('@/assets/images/Gallery_Sketching_6.jpg'),
  require('@/assets/images/Gallery_R4_9186.jpg'),
  require('@/assets/images/Gallery_R4_8904.jpg'),
  require('@/assets/images/Gallery_R4_8786.jpg'),
  require('@/assets/images/Gallery_R3_2058.jpg'),
  require('@/assets/images/Gallery_R3_2040.jpg'),
  require('@/assets/images/Gallery_R3_2027.jpg'),
  require('@/assets/images/Gallery_R3_1990.jpg'),
  require('@/assets/images/Gallery_R3_1849.jpg'),
  require('@/assets/images/Gallery_R3_1531.jpg'),
  require('@/assets/images/Gallery_DSC7828.jpg'),
  require('@/assets/images/Gallery_DSC3043.jpg'),
  require('@/assets/images/Gallery_DSC0750.jpg'),
  require('@/assets/images/Gallery_01.jpg'),
  require('@/assets/images/Gallery_02.jpg'),
  require('@/assets/images/Gallery_DSC3428.jpg'),
  require('@/assets/images/Gallery_DSC3874.jpg'),
];

const engineeredSoftGoods = reactive<esg[]>([
  { class: { 'kUyKXm': true, expand: false }, img: require("@/assets/svg/win1.svg") },
  { class: { 'fpFRph': true, expand: false }, img: require("@/assets/svg/win2.svg") },
  { class: { 'bCWCZc': true, expand: false }, img: require("@/assets/svg/win3.svg") },
  { class: { 'bJNQDR': true, expand: false }, img: require("@/assets/svg/win4.svg") }
])

const anchorFlag = ref<boolean>(false)

//锚点定义
const Anchor0 = ref(null)
const Anchor1 = ref(null)
const Anchor3 = ref(null)
const Anchor5 = ref(null)
const Anchor6 = ref(null)
const Anchor7 = ref(null)
const Anchor11 = ref(null)

const scrollToAnchor = (ref: any) => {
  anchorFlag.value = false
  if (ref) {
    ref.scrollIntoView({ behavior: 'smooth' });
  }
};
// animate__fadeInUpBig
const item5Obj = reactive<any[]>([
  [
    { class: { item5_1_1: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Lamination' },
    { class: { item5_1_2: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Bonding' }
  ],
  [
    { class: { item5_2_1: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Forming' },
    { class: { item5_2_2: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Precision assembly' }
  ],
  [
    { class: { item5_3_1: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Textiles' },
    { class: { item5_3_2: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Electronic integration' }
  ],
  [
    { class: { item5_4_1: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Material library' },
    { class: { item5_4_2: true, animate__fadeInUpBig: false, animate__fadeOutDown: true }, text: 'Box build and pack-out' }
  ]
])

//item1动画
const handleAnimateItem1 = () => {
  item1Obj.forEach(res => {
    Object.keys(res.class).forEach(k => {
      res.class[k] = !res.class[k]
    })
  })
}

//item5动画
const handleSetAnimateItem5 = (n: number, flag: boolean, bool: boolean) => {
  if (flag) {
    let index = Math.floor(n / 2);
    if (n % 2 === 0) {
      item5Obj[index].forEach((res: any, i: number) => {
        if (i === 0) {
          res.class.animate__fadeInUpBig = bool;
          res.class.animate__fadeOutDown = !bool;
        }
      })
    } else {
      item5Obj[index].forEach((res: any, i: number) => {
        if (i === 1) {
          res.class.animate__fadeInUpBig = bool;
          res.class.animate__fadeOutDown = !bool;
        }
      })
    }
  } else {
    item5Obj[n].forEach((res: any) => {
      res.class.animate__fadeInUpBig = bool;
      res.class.animate__fadeOutDown = !bool;
    })
  }
}


//item4 的动画添加
const handleSetAnimate = (bool: boolean) => {
  engineeredSoftGoods.forEach(res => {
    res.class.expand = bool
  })
}

const OurPlatformRef = ref();
const OurCommitmentRef = ref();
const TimeLineWidthMiniRef = ref();
const TimeLineWidthRef = ref();
const TimeLineHeightRef = ref();
let flagS1 = true;
let direction = true;
let oldHeight = 1;
const handleEvent = (e: Event) => {
  let height = (<HTMLDivElement>e.target).scrollTop;
  direction = height - oldHeight > 0 ? true : false;
  oldHeight = height;
  let screenWidth = (<HTMLDivElement>e.target).clientWidth
  let Screen1Dom = <HTMLDivElement>document.querySelector("#Screen1");
  let Screen2Dom = <HTMLDivElement>document.querySelector("#Screen2");
  let Screen3Dom = <HTMLDivElement>document.querySelector("#Screen3");
  let Screen4Dom = <HTMLDivElement>document.querySelector("#Screen4");
  let Screen5Dom = <HTMLDivElement>document.querySelector("#Screen5");
  let Screen6Dom = <HTMLDivElement>document.querySelector("#Screen6");
  let Screen7Dom = <HTMLDivElement>document.querySelector("#Screen7");
  let Screen8Dom = <HTMLDivElement>document.querySelector("#Screen8");
  let Screen9Dom = <HTMLDivElement>document.querySelector("#Screen9");
  let Screen10Dom = <HTMLDivElement>document.querySelector("#Screen10");

  // console.log(Screen3Dom.style.activated)
  /* 第2屏 */
  if (height > (Screen1Dom?.offsetTop - 200) && Screen1Dom?.offsetTop + Screen1Dom?.clientHeight > height) {
    if (flagS1) {
      flagS1 = false
      handleAnimateItem1()
      setTimeout(function () {
        handleAnimateItem1()
      }, 1000 * 4)
    }
  } else {
    flagS1 = true;
  }

  //第3屏 our platform
  let s3h = document.querySelector('#OurPlatform1')?.clientHeight || 0;
  // let s3hl = document.querySelector('#OurPlatform3')?.clientHeight || 0;
  let item3Len = 2;
  let s3lastIndex = 0;
  let flag3 = false //布局变换 
  if (screenWidth < 769) {
    s3h = document.querySelector('#OurPlatform4')?.clientHeight || 0;
    flag3 = true;
    item3Len = 3
  }
  if (flag3) {
    if (height > (Screen2Dom?.offsetTop) && height < Screen3Dom?.offsetTop + 700) {

      for (let i = 0; i < item3Len; i++) {
        if (height > Screen2Dom?.offsetTop + s3h * i) {
          s3lastIndex = i
        }
      }
      OurPlatformRef.value.setAnimate(s3lastIndex, flag3, direction);
    }
  } else {

    if (height > (Screen2Dom?.offsetTop) && height < Screen3Dom?.offsetTop) {
      for (let i = 0; i < item3Len; i++) {
        if (height > Screen2Dom?.offsetTop + s3h * i) {
          s3lastIndex = i
        }
      }
      if (height > Screen2Dom?.offsetTop && height < Screen2Dom?.offsetTop + s3h) {
        OurPlatformRef.value.setAnimate(2, flag3, direction);
      }
      OurPlatformRef.value.setAnimate(s3lastIndex, flag3, direction);
    }
  }

  /* 第四屏  */
  let s4h = 0
  if (screenWidth < 900) {
    s4h = document.querySelector('#Screen4 .platform_one')?.clientHeight || 0
  }
  if (height > (Screen3Dom?.offsetTop + s4h) && height < Screen4Dom?.offsetTop + Screen4Dom?.clientHeight) {
    handleSetAnimate(true)
  } else {
    handleSetAnimate(false)
  }

  /* 图片 第五屏 our core capabilities*/
  let subItem5Height = document.querySelector('.item5_1_1')?.clientHeight || 0; //获取其中一个元素的高度
  let item5Len = item5Obj.length;
  let flag = false //布局变换
  let lastIndex = 0;
  if (screenWidth < 758) {
    item5Len = item5Len * 2;
    flag = true
  }
  if (height > (Screen4Dom?.offsetTop + 100) && height < Screen6Dom?.offsetTop - Screen5Dom?.clientHeight / 2) {
    for (let i = 0; i < item5Len; i++) {
      if (height > Screen4Dom?.offsetTop + 100 + subItem5Height * i) {
        lastIndex = i
      }
    }
    handleSetAnimateItem5(lastIndex, flag, direction);
  }

  /* our commitment */
  let s6h = document.querySelector('.kATuXq > div:first-child')?.clientHeight || 0;
  let s6hl = document.querySelector('.jNwXQJ')?.clientHeight || 0;
  let item6Len = 4;
  let s6lastIndex = 0;
  let flag6 = false //布局变换 
  if (screenWidth < 1024) {
    flag6 = true
  }
  if (height > Screen5Dom?.offsetTop + 200 && height < Screen7Dom?.offsetTop + 50) {
    if (flag6) {
      for (let i = 0; i < item6Len; i++) {
        if (height > Screen6Dom?.offsetTop + s6h * i) {
          s6lastIndex = i
        }
      }
      OurCommitmentRef.value.setAnimate(s6lastIndex, flag6, direction);
    } else {
      if (height > Screen6Dom?.offsetTop && height < Screen6Dom?.offsetTop + s6h) {
        for (let i = 0; i < 3; i++) {
          OurCommitmentRef.value.setAnimate(i, flag6, direction);
        }
      }
      if (height > Screen6Dom?.offsetTop && height < Screen6Dom?.offsetTop + s6h + s6hl) {
        OurCommitmentRef.value.setAnimate(3, flag6, direction);
      }
    }
  }

  /* 时间轴 */
  if (screenWidth < 768) {
    let s9h = document.querySelector('.fIjOrg .eBxUXz')?.clientHeight || 0;
    let item9Len = 4;
    let s9lastIndex = 0;
    if (height > Screen8Dom?.offsetTop + 200 && height < Screen9Dom?.offsetTop + 400) {
      // debugger
      // console.log(height)
      // console.log(Screen9Dom?.offsetTop)
      for (let i = 0; i < item9Len; i++) {
        if (height > Screen8Dom?.offsetTop + s9h * i) {
          s9lastIndex = i
        }
      }
      TimeLineWidthMiniRef.value.setAnimate(s9lastIndex, direction);
    }
  }

  if (768 < screenWidth && screenWidth < 1199) {
    // console.log('TimeLineWidth')
    let s9h = document.querySelector('.iTBeLL .gEFkGx')?.clientHeight || 0;
    let item9Len = 4;
    let s9lastIndex = 0;
    if (height > Screen8Dom?.offsetTop + 100 && height < Screen9Dom?.offsetTop) {
      // console.log(height)
      // console.log(Screen9Dom?.offsetTop)
      for (let i = 0; i < item9Len; i++) {
        if (height > Screen8Dom?.offsetTop + s9h * i) {
          s9lastIndex = i
        }
      }
      TimeLineWidthRef.value.setAnimate(s9lastIndex, direction);
    }
  }
  if (height < Screen8Dom.offsetTop) {
    for (let i = 0; i < 4; i++) {
      TimeLineWidthRef.value.setAnimate(i, false)
      TimeLineHeightRef.value.setAnimate(i, false)
    }
  }
  if (screenWidth > 1199) {
    // console.log('TimeLineHeight')
    let s9h = document.querySelector('.fBfNBt')?.clientHeight || 0;
    let item9Len = 4;
    let s9lastIndex = 0;
    if (height > Screen8Dom?.offsetTop && height < Screen10Dom?.offsetTop) {
      for (let i = 0; i < item9Len; i++) {
        if (height > Screen8Dom?.offsetTop + s9h / 4 * i) {
          s9lastIndex = i
        }
      }
      direction && TimeLineHeightRef.value.setAnimate(s9lastIndex, direction);
    }
  }
  if (height > Screen9Dom.offsetTop) {
    let dom = <HTMLDivElement>document.querySelector('.logo.hidden-sm-and-down')
    dom.classList.add('logo_hidden')
  } else {
    let dom = <HTMLDivElement>document.querySelector('.logo.hidden-sm-and-down')
    dom.classList.remove('logo_hidden')
  }

  /* 打开窗口 */
  if (height > (Screen9Dom?.offsetTop + 200) && height < Screen10Dom?.offsetTop + Screen10Dom?.clientHeight) {
    flagClose.value = true
  }
}

onMounted(() => {

  document.querySelector('#HomeContainer')?.addEventListener('scroll', handleEvent)

  window.addEventListener('resize', handleEvent)

  //首屏动画
  item0Obj.forEach((res: any, index: number) => {
    setTimeout(function () {
      res.class.animate__fadeInUpBig = true
    }, 500 * index)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (anchorFlag.value = !anchorFlag.value)),
      width: "40",
      y: "top",
      x: "left",
      class: "pages__Logo-sc-6kvjaa-1 ixmWVD"
    }, [
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(["pages__CloseIcon-sc-6kvjaa-3", { dajiwm: !anchorFlag.value, frUTtU: anchorFlag.value }])
      }, _hoisted_7, 2)
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass(["Menu__MenuWrap-sc-13vj53r-1", { wwBfM: anchorFlag.value, gmhrqm: !anchorFlag.value }]),
      open: ""
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { fhKjqg: anchorFlag.value, gOMZwO: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollToAnchor(Anchor0.value)))
          }, "Home")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { daMHlj: anchorFlag.value, gOMZwl: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollToAnchor(Anchor3.value)))
          }, "Platform")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { ernVie: anchorFlag.value, gOMZvE: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToAnchor(Anchor5.value)))
          }, "Capabilities")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { bpiRaJ: anchorFlag.value, gOMZzX: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (scrollToAnchor(Anchor6.value)))
          }, "Innovation")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { hsklmY: anchorFlag.value, gOMZzq: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (scrollToAnchor(Anchor7.value)))
          }, "Commitment")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { flmJib: anchorFlag.value, gOMZyN: !anchorFlag.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (scrollToAnchor(Anchor11.value)))
          }, "Locations")
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { gBNXeW: anchorFlag.value, gOMZyg: !anchorFlag.value }])
        }, _hoisted_9, 2),
        _createElementVNode("li", {
          class: _normalizeClass(["Menu__MenuItemWrap-sc-13vj53r-0", { hmcmSV: anchorFlag.value, gOMZCz: !anchorFlag.value }])
        }, _hoisted_12, 2)
      ])
    ], 2),
    _createElementVNode("div", {
      id: "Screen0",
      ref_key: "Anchor0",
      ref: Anchor0,
      class: "item0 common_item"
    }, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item0Obj, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["animate__animated", item.class]),
            style: _normalizeStyle({ visibility: item.class.animate__fadeInUpBig ? '' : 'hidden' })
          }, _toDisplayString(item.text), 7))
        }), 256))
      ])
    ], 512),
    _createElementVNode("div", {
      id: "Screen1",
      ref_key: "Anchor1",
      ref: Anchor1,
      class: "item1 common_item"
    }, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", { onClick: handleAnimateItem1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1Obj, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(item.class)
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.nText), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.text), 1)
            ], 2))
          }), 256))
        ])
      ]),
      _hoisted_17
    ], 512),
    _hoisted_18,
    _createElementVNode("div", {
      id: "Screen3",
      ref_key: "Anchor3",
      ref: Anchor3,
      class: "item3"
    }, [
      _createVNode(OurPlatform, {
        ref_key: "OurPlatformRef",
        ref: OurPlatformRef
      }, null, 512)
    ], 512),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(engineeredSoftGoods, (item, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              class: _normalizeClass(item.class),
              src: item.img
            }, null, 10, _hoisted_22))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: "Screen5",
      ref_key: "Anchor5",
      ref: Anchor5,
      class: "item5",
      style: {"background-color":"#fff","position":"relative"}
    }, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item5Obj, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_row, {
            gutter: 10,
            class: "item_common",
            key: index
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (res, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  xs: 24,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12,
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["animate__animated", res.class])
                    }, [
                      _createElementVNode("div", null, _toDisplayString(res.text), 1)
                    ], 2),
                    _hoisted_25
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", {
      id: "Screen6",
      ref_key: "Anchor6",
      ref: Anchor6,
      class: "item6 common_item"
    }, [
      _createVNode(_component_el_row, {
        gutter: 10,
        style: {"height":"inherit"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 12,
            class: "platform_one"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 12,
            class: "platform_two"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_carousel, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                    return _createVNode(_component_el_carousel_item, {
                      key: item,
                      class: _normalizeClass('item6_carousel' + item)
                    }, null, 8, ["class"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512),
    _createElementVNode("div", {
      id: "Screen7",
      ref_key: "Anchor7",
      ref: Anchor7,
      class: "item7"
    }, [
      _createVNode(OurCommitment, {
        ref_key: "OurCommitmentRef",
        ref: OurCommitmentRef
      }, null, 512)
    ], 512),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_el_row, {
        gutter: 10,
        style: {"height":"inherit"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 12,
            class: "platform_one"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 12,
            class: "platform_two"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_carousel, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
                    return _createVNode(_component_el_carousel_item, {
                      key: item,
                      class: _normalizeClass('item6_carousel' + item)
                    }, null, 8, ["class"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(TimeLineWidthMini, {
        ref_key: "TimeLineWidthMiniRef",
        ref: TimeLineWidthMiniRef,
        class: "hidden-sm-and-up"
      }, null, 512),
      _createVNode(TimeLineWidth, {
        ref_key: "TimeLineWidthRef",
        ref: TimeLineWidthRef,
        class: "hidden-xs-only hidden-lg-only hidden-xl-only"
      }, null, 512),
      _createVNode(TimeLineHeight, {
        ref_key: "TimeLineHeightRef",
        ref: TimeLineHeightRef,
        class: "hidden-xs-only hidden-sm-only hidden-md-only"
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _withDirectives(_createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", {
            class: "hTaCfR",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (flagClose.value = !flagClose.value))
          }),
          _hoisted_33,
          _createElementVNode("div", null, [
            _createElementVNode("h1", null, [
              _createTextVNode("We’d love to show you some of our products, but due to the NDAs we signed, we’ll have to leave it to your imagination! "),
              _createElementVNode("img", {
                alt: "smiley",
                src: require('@/assets/images/smiley.png')
              }, null, 8, _hoisted_34)
            ])
          ])
        ], 512), [
          [_vShow, flagClose.value]
        ])
      ]),
      _createVNode(_component_el_carousel, { height: "inherit" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listImg, (item) => {
            return _createVNode(_component_el_carousel_item, { key: item }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"width":"100%","height":"100%"},
                  src: item,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      id: "Screen11",
      ref_key: "Anchor11",
      ref: Anchor11,
      class: "item11"
    }, [
      _createVNode(MapItem)
    ], 512),
    _createElementVNode("div", _hoisted_35, [
      _createVNode(Certifications)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(Contact)
    ])
  ]))
}
}

})